<template>
  <div>
    <div class="bigTitle">Industry Expertise</div>
    <div class="box">
      <div class="value physicians">
        <div class="img">
        <img src="	https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/healthCare/healthcarebg.png" alt="">

        </div>
        <div class="title">Healthcare</div>
        <div class="text">
          <div class="one">
            For nearly 10 years，Holden Healthcare has been a leader in Healthcare market research in Asia. Holden works directly with market research agencies and consultancies outside Asia, to support pharmaceutical and medical device companies in making decisions that affect healthcare outcomes around the region.
          </div>
        </div>
        <div class="more" @click="toPath('/healthcare?source=webtable')">
          Find out more ＞
        </div>
      </div>
      <div class="value patient" >
        <div class="img">
        <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/medTech/medTechbg.png" alt="">

        </div>
        <div class="title">MedTech</div>
        <div class="text">
          <div class="one">
           We support our MedTech clients’ success in by providing comprehensive research solutions in Asia, including both quantitative and qualitative studies, modeling & analytics, and consulting services.

          </div>
        </div>
        <div class="more" @click="toPath('/medTech?source=webtable')">
                Find out more ＞
        </div>
      </div>
      <div class="value consumer">
        <div class="img">
        <img src="	https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/industryConsumer/consumerbg.png" alt="">

        </div>
        <div class="title">Consumer</div>
        <div class="text">
          <div class="one">
           Given the fast-paced economic development of many Asian markets, Holden provides you consumer insight for your product development, marketing efficiency, consumer segmentation, and experience management.
          </div>
        </div>
        <div class="more" @click="toPath('/industryConsumer?source=webtable')">
           Find out more ＞
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    toPath(path) {
      this.$router.push({
        path
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.bigTitle{
  font-size: 40px;
  padding: 30px 120px 0;
  font-weight: 700;
}
.box {
  display: flex;
  justify-content: space-between;
  margin: 40px 120px 90px;
  .value {
    width: 32%;
    position: relative;

    // border: 1px solid #000;
     background-color: #2cb1e9;
      padding: 20px 20px 50px;
    color: #fff;
    .title {
      font-size: 20px;
      font-weight: 700;
    }
    .img {
      width: 150px;
      overflow: hidden;
      img {
        width: 300px;
        transform: translateX(-50%); /* 向左平移50%以显示右半边 */
      }
    }
    .text {
      .one,
      .two {
        margin-top: 10px;
      }
    }
    .more {
        position: absolute;
  bottom: 15px;
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }
  }
}
@media screen and (max-width: 576px) {
  .bigTitle{
    font-size: 80px;
  }
  .box{
    flex-wrap: wrap;
    .value{
      width: 100%;
      padding: 30px;
      margin-bottom: 20px;
      padding-bottom: 150px;
      .title{
        font-size: 75px;
      }
      .img{
        width: 500px;
        img{
          width: 1000px;
        }
      }
      .text{
        font-size: 70px;
      }
      .more{
        font-size: 70px;
      }
    }
  }
}
</style>